import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import Input from "../../../../../components/textbox/Input";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import MalattieService from "../../../../../services/MalattieService";
import {withTranslation} from "react-i18next";
import Select from "../../../../../components/select/Select"

class InfoMadre extends Component {
    state = {
        infoMadre: {
            nomeECognome: "",
            eta: "",
            occupazioneAlconcepimento: "",
            vaccinzaioneControMalattia: "",
            dataDiVaccinazione: "",
            testScreeningPreGravidanza: "",
            dataTestPre: "",
            risultatoTestPre: "",
            testScreeningPostGravidanza: "",
            dataTestPost: "",
            risultatoTestPost: "",
            malattiaSimileRosolia: "",
            settimanaEsordio: "",
            dataEsordio: "",
            informazioniCliniche: "",
            esposizioneCasoNoto: "",
            fonteEsposizione: "",
            luogoContagio: "",
            informazioniLaboratorio: "",
            corretto: []
        },
        listaInfoLaboratorio: [],
        listaInfoCliniche: []
    }

    constructor(props) {
        super(props);
        this.setSelects = this.setSelects.bind(this)
        this.setInput = this.setInput.bind(this)
        this.setDates = this.setDates.bind(this)
        this.validate = this.validate.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
    }

    componentDidMount() {
        this.props.setInfoMadre(undefined, this)

        MalattieService.getInfoCliniche(this.props.malattia).then((data) => {
            let listaInfoCliniche = Utils.mapToArray(data.data);
            sessionStorage.setItem("listaInfoCliniche", JSON.stringify(listaInfoCliniche));
            this.setState({listaInfoCliniche: listaInfoCliniche})
        }).catch(() => {
            console.log("errore chiamata info cliniche")
        });

        MalattieService.getInfoLaboratorio(this.props.malattia).then((data) => {
            let listaInfoLaboratorio = Utils.mapToArray(data.data);
            sessionStorage.setItem("listaInfoLaboratorio", JSON.stringify(listaInfoLaboratorio));
            this.setState({listaInfoLaboratorio: listaInfoLaboratorio})
        }).catch(() => {
            console.log("errore chiamata info laboratorio")
        });
        if (this.props.segnalazioneCopia.datiSpecifici) {
            if (this.props.segnalazioneCopia.datiSpecifici.infoMadre) {
                let infoMadre = this.state.infoMadre;
                let infoMadreCopia = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici))
                infoMadre.nomeECognome = infoMadreCopia.infoMadre.nomeECognome ? infoMadreCopia.infoMadre.nomeECognome : ""
                infoMadre.eta = infoMadreCopia.infoMadre.eta ? infoMadreCopia.infoMadre.eta : ""
                infoMadre.occupazioneAlconcepimento = infoMadreCopia.infoMadre.occupazioneAlconcepimento ? infoMadreCopia.infoMadre.occupazioneAlconcepimento : ""
                infoMadre.vaccinzaioneControMalattia = infoMadreCopia.infoMadre.vaccinzaioneControMalattia ? infoMadreCopia.infoMadre.vaccinzaioneControMalattia : ""
                infoMadre.dataDiVaccinazione = infoMadreCopia.infoMadre.dataDiVaccinazione ? infoMadreCopia.infoMadre.dataDiVaccinazione : ""
                infoMadre.testScreeningPreGravidanza = infoMadreCopia.infoMadre.testScreeningPreGravidanza ? infoMadreCopia.infoMadre.testScreeningPreGravidanza : ""
                infoMadre.dataTestPre = infoMadreCopia.infoMadre.dataTestPre ? infoMadreCopia.infoMadre.dataTestPre : ""
                infoMadre.risultatoTestPre = infoMadreCopia.infoMadre.risultatoTestPre ? infoMadreCopia.infoMadre.risultatoTestPre : ""
                infoMadre.testScreeningPostGravidanza = infoMadreCopia.infoMadre.testScreeningPostGravidanza ? infoMadreCopia.infoMadre.testScreeningPostGravidanza : ""
                infoMadre.dataTestPost = infoMadreCopia.infoMadre.dataTestPost ? infoMadreCopia.infoMadre.dataTestPost : ""
                infoMadre.risultatoTestPost = infoMadreCopia.infoMadre.risultatoTestPost ? infoMadreCopia.infoMadre.risultatoTestPost : ""
                infoMadre.malattiaSimileRosolia = infoMadreCopia.infoMadre.malattiaSimileRosolia ? infoMadreCopia.infoMadre.malattiaSimileRosolia : ""
                infoMadre.settimanaEsordio = infoMadreCopia.infoMadre.settimanaEsordio ? infoMadreCopia.infoMadre.settimanaEsordio : ""
                infoMadre.dataEsordio = infoMadreCopia.infoMadre.dataEsordio ? infoMadreCopia.infoMadre.dataEsordio : ""
                infoMadre.informazioniCliniche = infoMadreCopia.infoMadre.informazioniCliniche ? infoMadreCopia.infoMadre.informazioniCliniche : ""
                infoMadre.esposizioneCasoNoto = infoMadreCopia.infoMadre.esposizioneCasoNoto ? infoMadreCopia.infoMadre.esposizioneCasoNoto : ""
                infoMadre.fonteEsposizione = infoMadreCopia.infoMadre.fonteEsposizione ? infoMadreCopia.infoMadre.fonteEsposizione : ""
                infoMadre.luogoContagio = infoMadreCopia.infoMadre.luogoContagio ? infoMadreCopia.infoMadre.luogoContagio : ""
                infoMadre.informazioniLaboratorio = infoMadreCopia.infoMadre.informazioniLaboratorio ? infoMadreCopia.infoMadre.informazioniLaboratorio : ""
            }
        }
        this.controlloCorrettezza()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            this.props.setInfoMadre(this.state.infoMadre, this)
        }
    }

    controlloCorrettezza() {
        let infoMadre = this.state.infoMadre
        infoMadre.corretto = []

        if(!infoMadre.nomeECognome) infoMadre.corretto[0] = "Campo \"Cognome e nome della madre\" mancante"
        else infoMadre.corretto[0] = ""
        if(!infoMadre.eta) infoMadre.corretto[1] = "Campo \"Età al momento del parto\" mancante"
        else infoMadre.corretto[1] = ""
        if(this.state.infoMadre.vaccinzaioneControMalattia === "1" && !infoMadre.dataDiVaccinazione || ( infoMadre.dataDiVaccinazione && Utils.isDateInValid(Utils.transformDateForBackend(infoMadre.dataDiVaccinazione), "-"))){
                infoMadre.corretto[2] = "Campo \"Data vaccinazione\" mancante o errato"
        } else infoMadre.corretto[2] = ""
        if (infoMadre.testScreeningPreGravidanza === "1") {
            if (infoMadre.dataTestPre === null || infoMadre.dataTestPre === undefined || infoMadre.dataTestPre === "" || (infoMadre.dataTestPre && Utils.isDateInValid(Utils.transformDateForBackend(infoMadre.dataTestPre), "-"))) {
                infoMadre.corretto[3] = "Campo \"Data esecuzione\" mancante o errato"
            } else infoMadre.corretto[3] = ""
            if(infoMadre.risultatoTestPre === null || infoMadre.risultatoTestPre === undefined || infoMadre.risultatoTestPre === ""){
                infoMadre.corretto[4] = "Campo \"Risultato test\" mancante"
            } else infoMadre.corretto[4] = ""
        }
        if (infoMadre.testScreeningPostGravidanza === "1") {
            if (infoMadre.dataTestPost === null || infoMadre.dataTestPost === undefined || infoMadre.dataTestPost === "" || Utils.isDateInValid(Utils.transformDateForBackend(infoMadre.dataTestPost), "-")){
                infoMadre.corretto[5] = "Campo \"Data esecuzione\" mancante o errato"
            } else infoMadre.corretto[5] = ""
            if(infoMadre.risultatoTestPost === null || infoMadre.risultatoTestPost === undefined || infoMadre.risultatoTestPost === ""){
                infoMadre.corretto[6] = "Campo \"Risultato test\" mancante"
            } else infoMadre.corretto[6] = ""
        }
        if (infoMadre.malattiaSimileRosolia === "1" && ( infoMadre.settimanaEsordio === null || infoMadre.settimanaEsordio === undefined || infoMadre.settimanaEsordio === "")) {
            infoMadre.corretto[7] = "Campo \"Settimana\" mancante"
        } else infoMadre.corretto[7] = ""
        if (infoMadre.esposizioneCasoNoto === "1" && ( infoMadre.fonteEsposizione === null || infoMadre.fonteEsposizione === undefined || infoMadre.fonteEsposizione === "")) {
            infoMadre.corretto[8] = "Campo \"Fonte di esposizione\" mancante"
        } else infoMadre.corretto[8] = ""
        if(infoMadre.dataEsordio && Utils.isDateInValid(Utils.transformDateForBackend(infoMadre.dataEsordio), "-")){
            infoMadre.corretto[9] = "Campo \"Data esordio\" errato"
        } else infoMadre.corretto[9] = ""

        this.setState({infoMadre: infoMadre})
    }

    validate() {
        let validateDataVaccinazione = Utils.checkDateInterval(this.state.infoMadre.dataDiVaccinazione, "31/12/1899");
        let checkTodayDataVaccinazione = Utils.checkDateLowerToday(this.state.infoMadre.dataDiVaccinazione);
        let validateDataEsordio = Utils.checkDateInterval(this.state.infoMadre.dataEsordio, "31/12/1899");
        let checkTodayDataEsordio = Utils.checkDateLowerToday(this.state.infoMadre.dataEsordio);
        let validateDataTestPre = Utils.checkDateInterval(this.state.infoMadre.dataTestPre, "31/12/1899");
        let checkTodayDataTestPre = Utils.checkDateLowerToday(this.state.infoMadre.dataTestPre);
        let validateDataTestPost = Utils.checkDateInterval(this.state.infoMadre.dataTestPost, "31/12/1899");
        let checkTodayDataTestPost = Utils.checkDateLowerToday(this.state.infoMadre.dataTestPost);

        if (validateDataVaccinazione) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_AM"]), 1
            )
        } else if (checkTodayDataVaccinazione) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_AN"]), 1
            )
        }
        if (validateDataEsordio) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_AQ"]), 1
            )
        } else if (checkTodayDataEsordio) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_AR"]), 1
            )
        }
        if (validateDataTestPre || validateDataTestPost) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_AO"]), 1
            )
        } else if (checkTodayDataTestPre || checkTodayDataTestPost) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_AP"]), 1
            )
        }

        if (this.state.infoMadre.settimanaEsordio && (parseInt(this.state.infoMadre.settimanaEsordio) < 1 || parseInt(this.state.infoMadre.settimanaEsordio) > 36)) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DI"]), 1
            )
        }

        if (!this.state.infoMadre.vaccinzaioneControMalattia && this.state.infoMadre.dataDiVaccinazione) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DOTEMP"]), 1
            )
        }

        if ((this.state.infoMadre.vaccinzaioneControMalattia === "2" || this.state.infoMadre.vaccinzaioneControMalattia === "3") && this.state.infoMadre.dataDiVaccinazione) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CN"]), 1
            )
        }


        if (!this.state.infoMadre.testScreeningPreGravidanza && this.state.infoMadre.dataTestPre) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DQTEMP"]), 1
            )
        }
        if (!this.state.infoMadre.testScreeningPreGravidanza && this.state.infoMadre.risultatoTestPre) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DSTEMP"]), 1
            )
        }
        if ((this.state.infoMadre.testScreeningPreGravidanza === "2" || this.state.infoMadre.testScreeningPreGravidanza === "3") && this.state.infoMadre.dataTestPre) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CO"]), 1
            )
        }
        if ((this.state.infoMadre.testScreeningPreGravidanza === "2" || this.state.infoMadre.testScreeningPreGravidanza === "3") && this.state.infoMadre.risultatoTestPre) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CP"]), 1
            )
        }


        if (!this.state.infoMadre.testScreeningPostGravidanza && this.state.infoMadre.dataTestPost) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DU"]), 1
            )
        }
        if (!this.state.infoMadre.testScreeningPostGravidanza && this.state.infoMadre.risultatoTestPost) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_DZTEMP"]), 1
            )
        }
        if ((this.state.infoMadre.testScreeningPostGravidanza === "2" || this.state.infoMadre.testScreeningPostGravidanza === "3") && this.state.infoMadre.dataTestPost) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CQ"]), 1
            )
        }
        if ((this.state.infoMadre.testScreeningPostGravidanza === "2" || this.state.infoMadre.testScreeningPostGravidanza === "3") && this.state.infoMadre.risultatoTestPost) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CR"]), 1
            )
        }


        if (!this.state.infoMadre.malattiaSimileRosolia && this.state.infoMadre.settimanaEsordio) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_EB"]), 1
            )
        }
        if (!this.state.infoMadre.malattiaSimileRosolia && this.state.infoMadre.dataEsordio) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_ED"]), 1
            )
        }
        if (!this.state.infoMadre.malattiaSimileRosolia && this.state.infoMadre.fonteEsposizione) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_EF"]), 1
            )
        }
        if (!this.state.infoMadre.malattiaSimileRosolia && this.state.infoMadre.luogoContagio) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_EH"]), 1
            )
        }
        if ((this.state.infoMadre.malattiaSimileRosolia === "2" || this.state.infoMadre.malattiaSimileRosolia === "3") && this.state.infoMadre.settimanaEsordio) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CS"]), 1
            )
        }
        if ((this.state.infoMadre.malattiaSimileRosolia === "2" || this.state.infoMadre.malattiaSimileRosolia === "3") && this.state.infoMadre.dataEsordio) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CT"]), 1
            )
        }
        if ((!this.state.infoMadre.esposizioneCasoNoto || this.state.infoMadre.esposizioneCasoNoto === "3") && this.state.infoMadre.fonteEsposizione) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CU"]), 1
            )
        }
        if ((!this.state.infoMadre.esposizioneCasoNoto || this.state.infoMadre.esposizioneCasoNoto === "3") && this.state.infoMadre.luogoContagio) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_CV"]), 1
            )
        }


        let infoMadre = Object.assign({}, this.state.infoMadre)
        let infoMadreObj = Utils.removeFieldFromObject(infoMadre, "corretto");
        this.props.setInfoMadre(undefined, undefined, infoMadreObj)
    }

    setSelects(event) {
        let infoMadre = this.state.infoMadre
        if (event.target.id === "occupazioneAlconcepimento") {
            infoMadre.occupazioneAlconcepimento = event.target.value
        } else if (event.target.id === "vaccinzaioneControMalattia") {
            infoMadre.vaccinzaioneControMalattia = event.target.value
        } else if (event.target.id === "testScreeningPreGravidanza") {
            infoMadre.testScreeningPreGravidanza = event.target.value
        } else if (event.target.id === "risultatoTestPre") {
            infoMadre.risultatoTestPre = event.target.value
        } else if (event.target.id === "testScreeningPostGravidanza") {
            infoMadre.testScreeningPostGravidanza = event.target.value
        } else if (event.target.id === "risultatoTestPost") {
            infoMadre.risultatoTestPost = event.target.value
        } else if (event.target.id === "malattiaSimileRosolia") {
            infoMadre.malattiaSimileRosolia = event.target.value
        } else if (event.target.id === "informazioniCliniche") {
            infoMadre.informazioniCliniche = event.target.value
        } else if (event.target.id === "esposizioneCasoNoto") {
            infoMadre.esposizioneCasoNoto = event.target.value
        } else if (event.target.id === "fonteEsposizione") {
            infoMadre.fonteEsposizione = event.target.value
        } else if (event.target.id === "luogoContagio") {
            infoMadre.luogoContagio = event.target.value
        } else if (event.target.id === "informazioniLaboratorio") {
            infoMadre.informazioniLaboratorio = event.target.value
        }
        this.setState({infoMadre: infoMadre})
        this.controlloCorrettezza()
        return false;
    }

    setInput(field, event) {
        let infoMadre = this.state.infoMadre
        if (field === "nomeECognome") {
            infoMadre.nomeECognome = event.target.value
        } else if (field === "eta") {
            infoMadre.eta = event.target.value
        } else if (field === "settimanaEsordio") {
            infoMadre.settimanaEsordio = event.target.value
        }

        this.setState({infoMadre: infoMadre})
        this.controlloCorrettezza()
        return false;

    }

    setDates(field) {
        let infoMadre = this.state.infoMadre
        if (field.currentTarget.id === "dataEsordio") {
            infoMadre.dataEsordio = field.target.value
        } else if (field.currentTarget.id === "dataTestPost") {
            infoMadre.dataTestPost = field.target.value
        } else if (field.currentTarget.id === "dataTestPre") {
            infoMadre.dataTestPre = field.target.value
        } else if (field.currentTarget.id === "dataDiVaccinazione") {
            infoMadre.dataDiVaccinazione = field.target.value
        }

        this.setState({infoMadre: infoMadre})
        this.controlloCorrettezza()

    }

    render() {
        console.log("infoMadre: " + JSON.stringify(Object.values(this.state.infoMadre)))
        const {t} = this.props
        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{this.props.t("DatiSpecifici.InfoMadre.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>

                    <div className="row">
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.anagraficaMadre")}<span
                                className={styles.mandatoryColor}>*</span></p>
                            <Input id={"nomeECognome"}
                                onChange={this.setInput}
                                field={"nomeECognome"}
                                errorMessage={"Nome e cognome non validi"}
                                value={this.state.infoMadre.nomeECognome}
                                placeholder={"Cognome e nome della madre"}
                            />
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.parto")}<span
                                className={styles.mandatoryColor}>*</span></p>
                            <Input id={"eta"}
                                type={"number"}
                                min="1"
                                oninput={this.state.infoMadre.eta ? this.state.infoMadre.eta |= 0 : null}
                                onChange={this.setInput}
                                field={"eta"}
                                errorMessage={"Età non valida"}
                                value={this.state.infoMadre.eta}
                                placeholder={"Età al momento del parto"}
                            />
                        </div>
                        <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.occupazione")}</p>
                            <Select
                                value={this.state.infoMadre.occupazioneAlconcepimento}
                                id={"occupazioneAlconcepimento"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.OccupazioneAlConcepimento).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}>
                            </Select>
                        </div>
                    </div>

                    <div className="row">
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.vaccinazione")}</p>
                            <Select
                                value={this.state.infoMadre.vaccinzaioneControMalattia}
                                id={"vaccinzaioneControMalattia"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.MadreVaccinata).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >
                            </Select>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.testo}>
                                {this.props.t("DatiSpecifici.InfoMadre.dataVaccinazione")}
                                {this.state.infoMadre.vaccinzaioneControMalattia === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                            <Calendar
                                id={"dataDiVaccinazione"} value={this.state.infoMadre.dataDiVaccinazione}
                                field={"dataDiVaccinazione"}
                                onChange={this.setDates}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    ("Data Di Vaccinazione Contro La Malattia"))}
                                error={(this.state.infoMadre.dataDiVaccinazione === "" ||
                                    this.state.infoMadre.dataDiVaccinazione == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.infoMadre.dataDiVaccinazione), "-")}
                            >
                            </Calendar>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.testGravidanza")}</p>
                            <Select
                                value={this.state.infoMadre.testScreeningPreGravidanza}
                                id={"testScreeningPreGravidanza"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.TestDiScreening).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >
                            </Select>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>
                                {this.props.t("DatiSpecifici.InfoMadre.dataTest")}
                                {this.state.infoMadre.testScreeningPreGravidanza === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                            <Calendar
                                id={"dataTestPre"} value={this.state.infoMadre.dataTestPre}
                                field={"dataTestPre"}
                                onChange={this.setDates}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    ("Data Di Test Pre-Gravidanza"))}
                                error={(this.state.infoMadre.dataTestPre === "" ||
                                    this.state.infoMadre.dataTestPre == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.infoMadre.dataTestPre), "-")}
                            >
                            </Calendar>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.testo}>
                                {this.props.t("DatiSpecifici.InfoMadre.risultatoTest")}
                                {this.state.infoMadre.testScreeningPreGravidanza === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                            <Select
                                value={this.state.infoMadre.risultatoTestPre}
                                id={"risultatoTestPre"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.RisultatoTest).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}>
                            </Select>
                        </div>
                    </div>

                    <div className="row">
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.TestScreening")}</p>
                            <Select
                                value={this.state.infoMadre.testScreeningPostGravidanza}
                                id={"testScreeningPostGravidanza"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.TestDiScreening).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >

                            </Select>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.dataTest")}
                                {this.state.infoMadre.testScreeningPostGravidanza === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}</p>
                            <Calendar
                                id={"dataTestPost"} value={this.state.infoMadre.dataTestPost}
                                field={"dataTestPost"}
                                onChange={this.setDates}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    ("Data Di Test Durante La Gravidanza"))}
                                error={(this.state.infoMadre.dataTestPost === "" ||
                                    this.state.infoMadre.dataTestPost == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.infoMadre.dataTestPost), "-")}
                            >
                            </Calendar>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.risultatoTest")}
                                {this.state.infoMadre.testScreeningPostGravidanza === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}</p>
                            <Select
                                value={this.state.infoMadre.risultatoTestPost}
                                id={"risultatoTestPost"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.RisultatoTest).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >
                            </Select>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.malattia")}</p>
                            <Select
                                value={this.state.infoMadre.malattiaSimileRosolia}
                                id={"malattiaSimileRosolia"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.MalattiaSimileAllaRosolia).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}>

                            </Select>
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>
                                {this.props.t("DatiSpecifici.InfoMadre.settimana")}
                                {this.state.infoMadre.malattiaSimileRosolia === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                            <Input id={"settimanaEsordio"}
                                onChange={this.setInput}
                                type={"number"}
                                field={"settimanaEsordio"}
                                errorMessage={"Settimana non valida"}
                                value={this.state.infoMadre.settimanaEsordio}
                                placeholder={"Settimana"}
                            />
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.dataEsordio")}</p>
                            <Calendar
                                id={"dataEsordio"} value={this.state.infoMadre.dataEsordio}
                                field={"dataEsordio"}
                                onChange={this.setDates}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    ("Data esordio"))}
                                error={(this.state.infoMadre.dataEsordio === "" ||
                                    this.state.infoMadre.dataEsordio == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.infoMadre.dataEsordio), "-")}
                            >
                            </Calendar>
                        </div>
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.info")}</p>
                            <Select
                                value={this.state.infoMadre.informazioniCliniche}
                                id={"informazioniCliniche"}
                                onChange={this.setSelects}
                                functionMap={this.state.listaInfoCliniche.map((oggetto) => {
                                    return (
                                        <option
                                            value={oggetto.codiceInfoClinica}>{oggetto.descrizioneInfoClinica}</option>)
                                })}>

                            </Select>
                        </div>
                    </div>


                    <div className="row">
                        <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.esposizione")}</p>
                            <Select
                                value={this.state.infoMadre.esposizioneCasoNoto}
                                id={"esposizioneCasoNoto"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.EsposizioneMadre).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}>

                            </Select>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.fonte")}
                                {this.state.infoMadre.esposizioneCasoNoto === "1" || this.state.infoMadre.esposizioneCasoNoto === "2" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""} </p>
                            <Select
                                value={this.state.infoMadre.fonteEsposizione}
                                id={"fonteEsposizione"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.FontiEsposizione).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}>

                            </Select>
                        </div>
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.luogo")}
                                {this.state.infoMadre.esposizioneCasoNoto === "1" || this.state.infoMadre.esposizioneCasoNoto === "2" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}</p>
                            <Select
                                value={this.state.infoMadre.luogoContagio}
                                id={"luogoContagio"}
                                onChange={this.setSelects}
                                functionMap={Utils.mapToArray(OggettiUtili.LuogoDelContatto).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}>

                            </Select>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-lg-12">
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.InfoMadre.infoLab")}</p>
                            <Select
                                value={this.state.infoMadre.informazioniLaboratorio}
                                id={"informazioniLaboratorio"}
                                onChange={this.setSelects}
                                functionMap={this.state.listaInfoLaboratorio.map((oggetto) => {
                                    return (<option
                                        value={oggetto.codiceInfoLaboratorio}>{oggetto.descrizioneInfoLaboratorio}</option>)
                                })}>

                            </Select>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(InfoMadre)
